import type { ToolContent } from "./tool-content";

interface PdfSeoOverride {
  h1Title: string;
  seoTitle: string;
  seoDescription: string;
  intro: string;
}

const PDF_SEO_DATA: Record<string, PdfSeoOverride> = {
  "merge-pdf": {
    h1Title: "Merge PDF Online Free — Combine PDF Files into One Document",
    seoTitle: "Merge PDF Online Free — Combine PDF Files into One Document | Picamini.online",
    seoDescription: "Merge PDF online free — no file upload, no account setup. Combine multiple PDF files into one clean document instantly in your browser.",
    intro: "Combine two or more PDF files into a single organized document online for free. Reorder pages, select custom page ranges, and download instantly with 100% data privacy and zero server uploads.",
  },
  "split-pdf": {
    h1Title: "Split PDF Pages Free Online — Separate & Extract PDF Files",
    seoTitle: "Split PDF Pages Free Online — Separate & Extract PDF Files | Picamini.online",
    seoDescription: "Split PDF online free — extract specific pages or separate multi-page PDF documents into individual files with zero server uploads.",
    intro: "Separate pages or extract custom page ranges into individual PDF documents easily. Fast, 100% private client-side PDF splitter with no file size limits.",
  },
  "compress-pdf": {
    h1Title: "Compress PDF Size Free Online — Reduce PDF File Size Without Quality Loss",
    seoTitle: "Compress PDF Size Free Online — Reduce PDF File Size | Picamini.online",
    seoDescription: "Compress PDF online free — reduce file size for fast email sending and web uploads without losing visual clarity. 100% private.",
    intro: "Reduce PDF file size for fast email attachments and web uploads. High compression ratio with maximum visual clarity preserved and zero data transfers to remote servers.",
  },
  "image-to-pdf": {
    h1Title: "JPG to PDF Converter Free Online — Convert Images & Photos to PDF",
    seoTitle: "JPG to PDF Converter Free Online — Convert Images & Photos to PDF | Picamini.online",
    seoDescription: "Convert JPG, PNG, WEBP & GIF images to PDF online free. Combine multiple photos into a formatted PDF document with custom margins.",
    intro: "Convert JPG, PNG, WEBP, and GIF photos into a clean single PDF document. Custom margins, page orientation, and instant local browser export.",
  },
  "pdf-to-image": {
    h1Title: "PDF to JPG Converter Free Online — Extract High Resolution Images",
    seoTitle: "PDF to JPG Converter Free Online — Extract High Resolution Images | Picamini.online",
    seoDescription: "Convert PDF to JPG or PNG images online free. Extract every page of your PDF file as a high-resolution image directly in your browser.",
    intro: "Convert every page of your PDF document into high-resolution JPG or PNG image files with crisp rendering quality and instant zip downloading.",
  },
  "watermark-pdf": {
    h1Title: "Add Watermark to PDF Free Online — Stamp Text or Logo on PDF",
    seoTitle: "Add Watermark to PDF Free Online — Stamp Text or Logo on PDF | Picamini.online",
    seoDescription: "Add watermark to PDF online free. Stamp custom text or logo image watermarks across your PDF pages with full opacity and position controls.",
    intro: "Protect your intellectual property by stamping text or logo watermarks across PDF pages. Custom font size, opacity, rotation angle, and 9-position placement grid.",
  },
  "protect-pdf": {
    h1Title: "Protect PDF with Password Free Online — Encrypt & Lock PDF Files",
    seoTitle: "Protect PDF with Password Free Online — Encrypt & Lock PDF Files | Picamini.online",
    seoDescription: "Protect PDF with password online free. Encrypt confidential PDF documents with 128-bit security and custom passwords directly on your device.",
    intro: "Encrypt confidential PDF documents with 128-bit security and custom open passwords. 100% client-side encryption ensures your password and files never leave your browser.",
  },
  "unlock-pdf": {
    h1Title: "Unlock PDF Password Free Online — Remove PDF Restrictions & Locks",
    seoTitle: "Unlock PDF Password Free Online — Remove PDF Restrictions & Locks | Picamini.online",
    seoDescription: "Unlock PDF online free — remove password protection and editing restrictions from PDF files you own. 100% private browser tool.",
    intro: "Remove owner passwords and printing or editing restrictions from PDF documents you own quickly and safely.",
  },
  "edit-pdf": {
    h1Title: "Edit PDF Online Free — Add Text, Annotations, Shapes & Drawings",
    seoTitle: "Edit PDF Online Free — Add Text, Annotations, Shapes & Drawings | Picamini.online",
    seoDescription: "Edit PDF online free — add text boxes, annotations, drawings, shapes, and images directly onto PDF pages without installing software.",
    intro: "Annotate, draw, insert text boxes, add images, and sign PDF files directly in your web browser with zero software installation and total privacy.",
  },
  "rotate-pdf": {
    h1Title: "Rotate PDF Pages Free Online — Turn & Reorient PDF Pages",
    seoTitle: "Rotate PDF Pages Free Online — Turn & Reorient PDF Pages | Picamini.online",
    seoDescription: "Rotate PDF pages online free. Rotate individual pages or the entire PDF document 90, 180, or 270 degrees permanently.",
    intro: "Fix upside-down or landscape pages by rotating specific pages or the entire PDF document 90, 180, or 270 degrees clockwise or counterclockwise.",
  },
  "sign-pdf": {
    h1Title: "Sign PDF Online Free — Add Digital Signature & E-Sign Documents",
    seoTitle: "Sign PDF Online Free — Add Digital Signature & E-Sign Documents | Picamini.online",
    seoDescription: "Sign PDF online free — draw your electronic signature or upload an image to e-sign agreements and contracts with zero file uploads.",
    intro: "Draw your electronic signature or upload an image to e-sign contracts, agreements, and forms securely inside your browser.",
  },
  "page-numbers": {
    h1Title: "Add Page Numbers to PDF Online Free — Custom Header & Footer Numbering",
    seoTitle: "Add Page Numbers to PDF Online Free — Header & Footer Numbering | Picamini.online",
    seoDescription: "Add page numbers to PDF online free. Customize number position, font size, margins, and page range formatting easily.",
    intro: "Number PDF document pages automatically with custom position, font size, margins, and page format options.",
  },
  "word-to-pdf": {
    h1Title: "Word to PDF Converter Online Free — Convert DOCX to PDF",
    seoTitle: "Word to PDF Converter Online Free — Convert DOCX to PDF | Picamini.online",
    seoDescription: "Convert Word DOCX & DOC documents to PDF online free. Fast, high-fidelity conversion preserving text formatting and tables.",
    intro: "Convert Word DOCX and DOC documents into clean, professional PDF files with high-fidelity formatting preservation.",
  },
  "pdf-to-word": {
    h1Title: "PDF to Word Converter Online Free — Convert PDF to Editable DOCX",
    seoTitle: "PDF to Word Converter Online Free — Convert PDF to Editable DOCX | Picamini.online",
    seoDescription: "Convert PDF to Word DOCX online free. Extract text, tables, and formatting into an editable Microsoft Word document.",
    intro: "Extract text and layout from PDF files into editable Word DOCX documents for quick content updates.",
  },
  "ocr-pdf": {
    h1Title: "OCR PDF Online Free — Recognize & Extract Text from Scanned PDFs",
    seoTitle: "OCR PDF Online Free — Recognize & Extract Text from Scanned PDFs | Picamini.online",
    seoDescription: "OCR PDF online free — Optical Character Recognition to convert scanned document images into searchable, copyable text.",
    intro: "Optical Character Recognition to turn scanned PDF images into searchable, copyable text directly inside your browser.",
  },
};

export function getPdfToolContent(slug: string, toolName: string): ToolContent {
  const seo = PDF_SEO_DATA[slug] || {
    h1Title: `${toolName} Online Free — 100% Client-Side PDF Tool`,
    seoTitle: `${toolName} Online Free — 100% Client-Side PDF Tool | Picamini.online`,
    seoDescription: `${toolName} online free — no file upload, no account setup. Fast, 100% private PDF tool running directly inside your web browser.`,
    intro: `${toolName} is a fast, 100% client-side browser utility designed for teachers, students, office professionals, and remote teams who need to modify or convert PDF documents without risking data privacy.`,
  };

  return {
    seoTitle: seo.seoTitle,
    seoDescription: seo.seoDescription,
    h1Title: seo.h1Title,
    intro: seo.intro,
    whatIs: [
      `${toolName} is a fast, 100% client-side browser utility designed for teachers, students, office professionals, and remote teams who need to modify or convert PDF documents without risking data privacy.`,
      `Unlike traditional online PDF converters that require uploading confidential files to third-party web servers, ${toolName} processes all document pages locally on your computer using browser JavaScript engines.`,
    ],
    howTo: [
      "Click the file dropzone or drag and drop your PDF file(s) into the stage.",
      "Adjust options such as page order, page ranges, rotation angle, password locks, or quality compression levels.",
      "Click the process button to run the local browser engine instantly.",
      "Save and download your newly formatted PDF document directly to your device.",
    ],
    features: [
      "100% Client-Side Security — Zero server uploads or file tracking.",
      "Instant Processing Speed — Zero queue waiting time; runs on local CPU.",
      "No File Size Limits — Modify large PDF books and documents without restrictions.",
      "Cross-Platform Compatibility — Works on Chrome, Safari, Firefox, Edge, iPad, and Android.",
      "No Signups or Watermarks — Free forever with clean export files.",
    ],
    benefits: [
      "Complete Data Privacy & Confidentiality",
      "No Account Creation or Credit Card Required",
      "Lightning Fast Local Execution Speed",
      "Works Offline or on Slow Internet Connections",
      "Preserves Document Formatting & Page Layouts",
    ],
    detailedGuide: [
      {
        heading: `Why Client-Side ${toolName} is Superior to Cloud Services`,
        paragraphs: [
          `When you use traditional online PDF converters, your sensitive contracts, student records, financial sheets, or medical records are uploaded to remote servers. This introduces privacy risks, potential data leaks, and compliance violations with GDPR or FERPA regulations.`,
          `Picamini.online's ${toolName} eliminates these security concerns by executing all binary parsing, page manipulation, text extraction, and file rendering inside your local browser memory space.`,
        ],
        bullets: [
          "Zero file transfers — your documents never touch any server disk.",
          "FERPA & GDPR compliant local document workflow for educators and businesses.",
          "High performance leveraging WebAssembly and modern browser JS engines.",
        ],
      },
    ],
    faq: [
      {
        q: `Is ${toolName} completely free to use?`,
        a: `${toolName} is 100% free with unlimited document processing and no hidden subscriptions or forced watermarks.`,
      },
      {
        q: "Are my PDF files uploaded to your server?",
        a: "No. All PDF processing happens 100% locally in your web browser using JavaScript. Your files never leave your device.",
      },
      {
        q: "Does this tool work on mobile devices and iPads?",
        a: `${toolName} is fully responsive and runs smoothly on smartphones, tablets, iPads, Chromebooks, and laptops.`,
      },
      {
        q: "Is there a limit on how many pages or files I can process?",
        a: "There are no arbitrary file or page count limits. You can process documents of any length supported by your device memory.",
      },
      {
        q: "Do I need to install any software or plugins?",
        a: "No software installation is required. Everything runs natively inside your standard web browser.",
      },
    ],
  };
}
